module.exports = __webpack_public_path__ + "static/media/Carousel3.a08bce2e.jpg";